import {entityProperties} from "./EntityProperties";

export const RequestEntityInfo = `
    query requestEntityInfo ($fullUid: String!)  {
        allEntities (condition: {fullUid: $fullUid}) {
            nodes {
                ${entityProperties}
            }
        }
    }
`